export default "__VITE_ASSET__65e1f15e__"